export default __webpack_public_path__ + "static/P1_Foreword_CMYK_Iraq-b6792e65e7a6b88049e896c5c09a5ba9.jpg";